import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IUser, IUserExternalRole } from '../models/User';

import { environment as ENV } from '../../environments/environment';
import { IPagingParams } from '../models/Common';
import { Utils } from '../core/Utils';

@Injectable({ providedIn: "root" })
export class UserService {
    constructor(private http: HttpClient) { }

    private readonly apiUrl = `${ENV.apiUrl}/users`;

    get(paging?: IPagingParams, filter?: { role?: string, search?: string }): Observable<{ items: IUser[], total: number }> {
        return this.http.get<{ items: IUser[], total: number }>(this.apiUrl, {
            params: Utils.sanitizeQueryParams({ ...filter, ...paging })
        });
    }

    /**
     * Check current user obligations.
     * @returns
     */
    checkObligations(): Observable<{
        count?: number,
        message?: string,
        url?: string
    }> {
        const url = `${this.apiUrl}/checkObligations`;
        return this.http.get<{
            count?: number,
            message?: string,
            url?: string
        }>(url);
    }

    /**
     * Get current user external roles.
     * @returns
     */
    getMyExternalRoles(): Observable<IUserExternalRole[]> {
        return this.http.get<IUserExternalRole[]>(`${this.apiUrl}/myExternalRoles`);
    }
}
